import { render, staticRenderFns } from "./metadataMaintenance.vue?vue&type=template&id=6da52ba2&scoped=true"
import script from "./metadataMaintenance.vue?vue&type=script&lang=js"
export * from "./metadataMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da52ba2",
  null
  
)

export default component.exports